import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var MdmModal = function MdmModal() {
  return import(
  /* webpackChunkName: "modal" */
  '~/components/atoms/Global/MdmModal.vue');
};

export default {
  name: 'YoutubeModal',
  components: {
    MdmModal: MdmModal
  },
  props: {
    showYoutubeModal: {
      type: Boolean,
      required: false
    },
    src: {
      type: Array,
      required: true
    }
  }
};